import { classnames } from '@aibees/shared/utils';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { AiAnalysisProfileCardsProps as Props } from './types';
import { ProfileLabelCard } from '../ai-analysis-content/components/profile-label-card';
import { useProfileLabelConfigs } from '../ai-analysis-content/config';

export const AiAnalysisProfileCards = memo(({ className }: Props) => {
  const labelConfigs = useProfileLabelConfigs();

  return (
    <Styled.Wrapper
      className={classnames('AiAnalysisProfileCards', className)}
      sx={SX.root}
      container
      justifyContent="space-between"
    >
      {labelConfigs.map(({ title, labels, colorMap }) => (
        <ProfileLabelCard
          key={title}
          title={title}
          labels={labels}
          colorMap={colorMap}
        />
      ))}
    </Styled.Wrapper>
  );
});

AiAnalysisProfileCards.displayName = 'AiAnalysisProfileCards';
